/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeleteImageResponseDto } from '../models/DeleteImageResponseDto';
import type { ImageUrlResponseDto } from '../models/ImageUrlResponseDto';
import type { PresignedUrlDto } from '../models/PresignedUrlDto';
import type { PresignedUrlResponseDto } from '../models/PresignedUrlResponseDto';
import type { ThumbnailUrlResponseDto } from '../models/ThumbnailUrlResponseDto';
import type { UploadImageDto } from '../models/UploadImageDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UploadsService {
  /**
   * Get thumbnail URL from full image URL
   * @param imageUrl Full image URL (e.g. from product.imagePath)
   * @returns ThumbnailUrlResponseDto Thumbnail URL (convention: _thumb before extension)
   * @throws ApiError
   */
  public static uploadsControllerGetThumbnailUrl(
    imageUrl: string,
  ): CancelablePromise<ThumbnailUrlResponseDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/uploads/thumbnail-url',
      query: {
        imageUrl: imageUrl,
      },
    });
  }
  /**
   * Upload a product image
   * @param formData Product image file
   * @returns ImageUrlResponseDto File uploaded successfully
   * @throws ApiError
   */
  public static uploadsControllerUploadProductImage(
    formData: UploadImageDto,
  ): CancelablePromise<ImageUrlResponseDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/uploads/product-image',
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }
  /**
   * Get a pre-signed URL for direct client upload
   * @param requestBody File information for presigned URL
   * @returns PresignedUrlResponseDto Pre-signed URL created successfully
   * @throws ApiError
   */
  public static uploadsControllerGetPresignedUrl(
    requestBody: PresignedUrlDto,
  ): CancelablePromise<PresignedUrlResponseDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/uploads/presigned-url',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }
  /**
   * Delete a file from S3
   * @param key Key or URL of the image to delete
   * @returns DeleteImageResponseDto File deleted successfully
   * @throws ApiError
   */
  public static uploadsControllerDeleteFile(
    key: string,
  ): CancelablePromise<DeleteImageResponseDto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/uploads/product-image/{key}',
      path: {
        key: key,
      },
      errors: {
        400: `Bad request`,
        401: `Unauthorized`,
        403: `Forbidden`,
      },
    });
  }
}
